import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import styles from 'styles/components/calendar.module.scss'
import { eachDayOfInterval, endOfWeek, eachWeekOfInterval, startOfMonth, endOfMonth } from 'date-fns'
import { MonthlyCalendarHeaderRow, OpenStoreCalendarRow } from 'components/Calendar/index'
import { StoreCalendarType } from 'types/storeCalendar'
import { getStoreCurrentMonth } from 'reducks/storeCalendar/selectors'
import { State } from 'index'

const getCalendarArray = (date: Date) => {
  const sundays = eachWeekOfInterval({
    start: startOfMonth(date),
    end: endOfMonth(date),
  })
  return sundays.map((sunday) => eachDayOfInterval({ start: sunday, end: endOfWeek(sunday) }))
}

type Props = {
  activeDate: Date | undefined
  storeCalendars: StoreCalendarType[]
  selectDate: (date: Date | undefined) => void
}

const OpenStoreCalendar: FC<Props> = (props) => {
  const { activeDate, selectDate, storeCalendars } = props

  const currentMonth = useSelector((state: State) => getStoreCurrentMonth(state))
  const calendar = getCalendarArray(currentMonth)

  return (
    <table className={styles.table}>
      <thead>
        <MonthlyCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <OpenStoreCalendarRow
            key={rowNum}
            activeDate={activeDate}
            storeCalendars={storeCalendars}
            selectDate={selectDate}
            row={row}
          />
        ))}
      </tbody>
    </table>
  )
}

export default OpenStoreCalendar
